import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IrwinIdTextField  from '../../incidentDetails/components/IrwinIdTextField';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import moment from 'moment';

class RelatedIrwinRecord extends Component {

  //TODO: Duplicated
  getDateString = (value) =>
  {
    return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
    return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  getStyle = (attributeName) =>
  {
    const outlineStyle = {outlineColor:'red', outlineStyle: 'dotted'};
    const incidentId = this.props.record.IncidentID;

    const matchingItems = this.props.AttributeDeltas[incidentId].filter( function(item){return (item.AttributeName === attributeName);} );
    return (matchingItems && matchingItems.length > 0) ? outlineStyle : null;
  }

  getElement = (attributeName, attributeTitle) =>
  {
    const incidentId = this.props.record.IncidentID;
    const matchingItems = this.props.AttributeDeltas[incidentId].filter( function(item){return (item.AttributeName === attributeName);} );
    const hasDiff =  (matchingItems && matchingItems.length > 0);
   
    return (hasDiff) ? (
      <Tooltip title={"Current FODR Value: " + matchingItems[0].FodrValue} arrow placement="right-start">
        <span style={{verticalAlign: "bottom", color: "blue" }}>
        {attributeTitle}
        <HelpIcon fontSize="small" color="primary" style={{ verticalAlign: "bottom" }} />
      </span>
    </Tooltip>) : attributeTitle;
  }

  render()
  {
    return (
      <Paper elevation={3}>
      <Table size="small">
      <TableBody>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>IRWIN ID:</TableCell>
        <TableCell><IrwinIdTextField irwinId={this.props.record.IrwinID}/></TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('ABCDMisc', 'ABCD Misc:')}</TableCell>
        <TableCell>{this.props.record.ABCDMisc}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('ADSPermissionState', 'ADS Permission State:')}</TableCell>
        <TableCell>{this.props.record.ADSPermissionState}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('CalculatedAcres', 'Calculated Acres:')}</TableCell>
        <TableCell>{this.props.record.CalculatedAcres != null ? parseFloat(this.props.record.CalculatedAcres).toFixed(2) : this.props.record.CalculatedAcres}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('ContainmentDateTime', 'Containment Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.ContainmentDateTime)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('ControlDateTime', 'Control Date Time:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.ControlDateTime)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('CreatedBySystem', 'Created By System:')}</TableCell>
        <TableCell>{this.props.record.CreatedBySystem}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('CreatedOnDateTime', 'Created On Date Time:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.CreatedOnDateTime)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IncidentSize', 'Incident Size:')}</TableCell>
        <TableCell>{this.props.record.IncidentSize}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('DispatchCenterID', 'Dispatch Center ID:')}</TableCell>
        <TableCell>{this.props.record.DispatchCenterID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('EstimatedContainmentDate', 'Estimated Containment Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.EstimatedContainmentDate)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('Fatalities', 'Fatalities:')}</TableCell>
        <TableCell>{this.props.record.Fatalities}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FinalFireReportApprovedBy', 'Final Fire Report Approved By:')}</TableCell>
        <TableCell>{this.props.record.FinalFireReportApprovedBy}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FinalFireReportApprovedByTitle', 'Final Fire Report Approved By Title:')}</TableCell>
        <TableCell>{this.props.record.FinalFireReportApprovedByTitle}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FinalFireReportApprovedByUnit', 'Final Fire Report Approved By Unit:')}</TableCell>
        <TableCell>{this.props.record.FinalFireReportApprovedByUnit}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FinalFireReportApprovedDate', 'Final Fire Report Approved Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.FinalFireReportApprovedDate)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FinalFireReportNarrative', 'Final Fire Report Narrative:')}</TableCell>
        <TableCell>{this.props.record.FinalFireReportNarrative}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FinalStrategyAttainedDateTime', 'Final Strategy Attained Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.FinalStrategyAttainedDateTime)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireCauseID', 'Fire Cause:')}</TableCell>
        <TableCell>{this.props.record.FireCause}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireCauseGeneralID', 'Fire Cause General:')}</TableCell>
        <TableCell>{this.props.record.FireCauseGeneral}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireCauseSpecificID', 'Fire Cause Specific:')}</TableCell>
        <TableCell>{this.props.record.FireCauseSpecific}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireCode', 'FireCode:')}</TableCell>
        <TableCell>{this.props.record.FireCode}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireDepartmentID', 'Fire Department ID:')}</TableCell>
        <TableCell>{this.props.record.FireDepartmentID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireDiscoveryDateTime', 'Fire Discovery Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.FireDiscoveryDateTime)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireIgnitionDateTime', 'Fire Ignition Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.FireIgnitionDateTime)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireMgmtComplexity', 'Fire Mgmt Complexity:')}</TableCell>
        <TableCell>{this.props.record.FireMgmtComplexity}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FireOutDateTime', 'Fire Out Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.FireOutDateTime)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FSJobCode', 'FS Job Code:')}</TableCell>
        <TableCell>{this.props.record.FSJobCode}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('FSOverrideCode', 'FS Override Code:')}</TableCell>
        <TableCell>{this.props.record.FSOverrideCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('GACC', 'GACC:')}</TableCell>
        <TableCell>{this.props.record.GACC}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('HasFatalities', 'Has Fatalities:')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.HasFatalities)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('HasInjuries', 'Has Injuries:')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.HasInjuries)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IncidentManagementOrganization', 'Incident Management Organization:')}</TableCell>
        <TableCell>{this.props.record.IncidentManagementOrganization}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IncidentName', 'Incident Name:')}</TableCell>
        <TableCell>{this.props.record.IncidentName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IncidentTypeCategory', 'Incident Type Category:')}</TableCell>
        <TableCell>{this.props.record.IncidentTypeCategory}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IncidentTypeKind', 'Incident Type Kind:')}</TableCell>
        <TableCell>{this.props.record.IncidentTypeKind}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IncidentStatus', 'Incident Status:')}</TableCell>
        <TableCell>{this.props.record.IncidentStatus}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('INFORMUserName', 'INFORM User Name:')}</TableCell>
        <TableCell>{this.props.record.INFORMUserName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('InitialFireStrategy', 'Initial Fire Strategy:')}</TableCell>
        <TableCell>{this.props.record.InitialFireStrategy}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('InitialLatitude', 'Initial Latitude:')}</TableCell>
        <TableCell >{this.props.record.InitialLatitude}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('InitialLongitude', 'Initial Longitude:')}</TableCell>
        <TableCell>{this.props.record.InitialLongitude}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('InitialResponseDateTime', 'Initial Response Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.InitialResponseDateTime)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('Injuries', 'Injuries:')}</TableCell>
        <TableCell>{this.props.record.Injuries}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('InNFPORS', 'In NFPORS?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.InNFPORS)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('InFuelTreatment', 'In Fuel Treatment?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.InFuelTreatment)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IsFireCauseInvestigated', 'Is Fire Cause Investigated?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.IsFireCauseInvestigated)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IsFireCodeRequested', 'Is Fire Code Requested?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.IsFireCodeRequested)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IsFSAssisted', 'Is FS Assisted?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.IsFSAssisted)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IsQuarantined', 'Is Quarantined?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.IsQuarantined)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('IsTrespass', 'Is Trespass?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.IsTrespass)}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('IsValid', 'Is Valid?')}</TableCell>
        <TableCell>{this.getYesNo(this.props.record.IsValid)}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('LocalIncidentIdentifier', 'Local Incident Identifier:')}</TableCell>
        <TableCell>{this.props.record.LocalIncidentIdentifier}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('y', 'Latitude')}</TableCell>
        <TableCell>{this.props.record.y}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('x', 'Longitude')}</TableCell>
        <TableCell>{this.props.record.x}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('ModifiedBySystem', 'Modified By System:')}</TableCell>
        <TableCell>{this.props.record.ModifiedBySystem}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('ModifiedOnDateTime', 'Modified On Date:')}</TableCell>
        <TableCell>{this.getDateString(this.props.record.ModifiedOnDateTime)}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('OtherStructuresDestroyed', 'Other Structures Destroyed:')}</TableCell>
        <TableCell>{this.props.record.OtherStructuresDestroyed}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('OtherStructuresThreatened', 'Other Structures Threatened:')}</TableCell>
        <TableCell>{this.props.record.OtherStructuresThreatened}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOCity', 'City:')}</TableCell>
        <TableCell>{this.props.record.POOCity}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOCounty', 'County:')}</TableCell>
        <TableCell>{this.props.record.POOCounty}</TableCell>
        
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('POODispatchCenterID', 'Dispatch Center ID:')}</TableCell>
        <TableCell>{this.props.record.POODispatchCenterID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOFips', 'Fips:')}</TableCell>
        <TableCell>{this.props.record.POOFips}</TableCell>

      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOJurisdictionalAgency', 'Jurisdictional Agency:')}</TableCell>
        <TableCell>{this.props.record.POOJurisdictionalAgency}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOJurisdictionalUnit', 'Jurisdictional Unit:')}</TableCell>
        <TableCell>{this.props.record.POOJurisdictionalUnit}</TableCell>

      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOLandownerCategory', 'Landowner Category:')}</TableCell>
        <TableCell>{this.props.record.POOLandownerCategory}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOLandownerKind', 'Landowner Kind:')}</TableCell>
        <TableCell>{this.props.record.POOLandownerKind}</TableCell>

      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOProtectingAgency', 'Protecting Agency:')}</TableCell>
        <TableCell>{this.props.record.POOProtectingAgency}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOProtectingUnit', 'Protecting Unit:')}</TableCell>
        <TableCell>{this.props.record.POOProtectingUnit}</TableCell>

      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('POOState', 'State:')}</TableCell>
        <TableCell>{this.props.record.POOState}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('PredominantFuelGroup', 'Fuel Group:')}</TableCell>
        <TableCell>{this.props.record.PredominantFuelGroup}</TableCell>

      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('PredominantFuelModel', 'Fuel Model:')}</TableCell>
        <TableCell>{this.props.record.PredominantFuelModel}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('ResidencesDestroyed', 'Residences Destroyed:')}</TableCell>
        <TableCell>{this.props.record.ResidencesDestroyed}</TableCell>

      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>{this.getElement('ResidencesThreatened', 'Residences Threatened:')}</TableCell>
        <TableCell>{this.props.record.ResidencesThreatened}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>{this.getElement('UniqueFireIdentifier', 'Unique Fire Identifier:')}</TableCell>
        <TableCell>{this.props.record.UniqueFireIdentifier}</TableCell>

      </TableRow>
      </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedIrwinRecord;
